import type { TranscriptionPreviewRootProps } from './TranscriptionPreview.styles'
import { TranscriptionPreviewRoot } from './TranscriptionPreview.styles'

export interface TranscriptionPreviewProps
  extends TranscriptionPreviewRootProps {
  value: string | null
}

export function TranscriptionPreview(
  props: TranscriptionPreviewProps
): JSX.Element {
  return (
    <TranscriptionPreviewRoot {...props}>
      {props.value}
    </TranscriptionPreviewRoot>
  )
}
